import React, { useEffect, useState, useCallback } from 'react';
import { useURLState } from '../../hooks/useURLState';

interface SearchBlogProps {
  searchInput: (query: string) => void;
  setQueryValue: (value: string) => void;
  queryValue: string;
}

const SearchBlog: React.FC<SearchBlogProps> = ({ searchInput, setQueryValue, queryValue }) => {
  const [searchValue, setSearchValue] = useState('');
  const { setSearchQuery } = useURLState();

  useEffect(() => {
    setSearchValue(queryValue);
    searchInput(queryValue);
  }, [queryValue, searchInput]);

  const updateUrlWithSearch = useCallback(
    (value: string) => {
      // Use the URL state manager instead of direct URL manipulation
      setSearchQuery(value, { resetPage: true });

      if (!value) {
        searchInput('');
      }
    },
    [setSearchQuery, searchInput]
  );

  const onKeyDownSearchInput = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      const { target } = e;
      const value = (target as HTMLInputElement).value;

      if (e.key === 'Enter') {
        setQueryValue(value);
        updateUrlWithSearch(value);
      }
    },
    [setQueryValue, updateUrlWithSearch]
  );

  const buttonClickEvent = useCallback(() => {
    setQueryValue(searchValue);
    updateUrlWithSearch(searchValue);
  }, [searchValue, setQueryValue, updateUrlWithSearch]);

  const onChangeHandler = useCallback((value: string) => {
    setSearchValue(value);
  }, []);

  return (
    <div
      className="search-container"
      style={{
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        borderRadius: '6px',
        border: '1.5px solid #acadac',
      }}
    >
      <input
        type="text"
        onKeyDown={onKeyDownSearchInput}
        onChange={(e) => onChangeHandler(e.target.value)}
        style={{
          fontSize: '22px',
          fontWeight: '300',
          fontFamily: "Arial, 'FontAwesome'",
          padding: '31px',
          paddingBottom: '32px',
          borderRadius: '6px 0 0 6px',
        }}
        className="form-control search-input"
        placeholder="&#xF002; Search by title or keyword"
        value={searchValue}
      />
      <button
        onClick={buttonClickEvent}
        style={{
          textAlign: 'center',
          letterSpacing: '0.2rem',
          width: '250px',
          fontSize: '30px',
          padding: '8px',
          background: '#fc6b03',
          border: '2px solid #fc6b03',
          borderRadius: '0 5px 5px 0',
        }}
      >
        Search
      </button>
    </div>
  );
};

// Add memo with custom equality check for performance
export default React.memo(SearchBlog, (prevProps, nextProps) => {
  return (
    prevProps.queryValue === nextProps.queryValue &&
    prevProps.searchInput === nextProps.searchInput &&
    prevProps.setQueryValue === nextProps.setQueryValue
  );
});
